// extracted by mini-css-extract-plugin
export default {"recos":"f7-z","productCardOverride":"g7-z","rowHasBadge":"h7-z"};